export default [
    {
        name: 'Select Mode',
        description: 'Click on individual geo records to translate',
    },
    {
        name: 'Box Selection',
        description:
            'Click on the map to start drawing a box. Click again to finalize the selection and choose the records within the box to translate.',
    },
];
